import { useState } from "react";
import axios from "axios";
import { Mail, Phone, Clock, Send, Check } from "lucide-react";
import { COMPANY, SERVICES } from "../lib/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm({ withService = false }) {
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", service: "", challenge: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const update = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name || !form.company || !form.email) {
      setError("Please fill in your name, company, and email.");
      return;
    }
    setStatus("loading");
    try {
      await axios.post(`${API}/contact`, form);
      setStatus("success");
    } catch (err) {
      setStatus("idle");
      setError("Something went wrong. Please try again or email us directly.");
    }
  };

  if (status === "success") {
    return (
      <div className="form-card" data-testid="contact-success">
        <div className="form-success">
          <div className="check"><Check size={28} /></div>
          <h3>Thank you — message received.</h3>
          <p>We've got your details and will respond within {COMPANY.responseTime.toLowerCase()}. Keep an eye on your inbox for next steps on your discovery call.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="form-card fade-up d1">
      <h3>Schedule a Discovery Call</h3>
      <p className="form-sub">Share a bit about your situation and we'll come prepared.</p>
      <form onSubmit={submit} noValidate data-testid="contact-form">
        <div className="form-row">
          <div className="fg">
            <label htmlFor="fn">Name</label>
            <input id="fn" name="name" value={form.name} onChange={update} placeholder="Your full name" required data-testid="contact-name" />
          </div>
          <div className="fg">
            <label htmlFor="co">Company</label>
            <input id="co" name="company" value={form.company} onChange={update} placeholder="Company name" required data-testid="contact-company" />
          </div>
        </div>
        <div className="form-row">
          <div className="fg">
            <label htmlFor="em">Email</label>
            <input id="em" type="email" name="email" value={form.email} onChange={update} placeholder="you@company.com" required data-testid="contact-email" />
          </div>
          <div className="fg">
            <label htmlFor="ph">Phone</label>
            <input id="ph" type="tel" name="phone" value={form.phone} onChange={update} placeholder="(555) 000-0000" data-testid="contact-phone" />
          </div>
        </div>
        {withService && (
          <div className="fg">
            <label htmlFor="sv">Service of Interest</label>
            <select id="sv" name="service" value={form.service} onChange={update} data-testid="contact-service">
              <option value="">Select a service (optional)</option>
              {SERVICES.map((s) => (
                <option key={s.slug} value={s.title}>{s.title}</option>
              ))}
            </select>
          </div>
        )}
        <div className="fg">
          <label htmlFor="msg">Current Challenge</label>
          <textarea id="msg" name="challenge" value={form.challenge} onChange={update} placeholder="Describe your biggest supply chain or warehouse challenge right now — system issues, inventory problems, upcoming implementation, or anything else on your plate..." data-testid="contact-challenge" />
        </div>
        {error && <p style={{ color: "#c0392b", fontSize: "0.82rem", marginBottom: 12 }} data-testid="contact-error">{error}</p>}
        <button type="submit" className="btn-submit" disabled={status === "loading"} data-testid="contact-submit">
          <span>{status === "loading" ? "Sending..." : "Send Message"}</span>
          <Send size={16} />
        </button>
      </form>
    </div>
  );
}

export function ContactDetails() {
  return (
    <>
      <div className="c-detail">
        <div className="c-icon"><Mail size={17} /></div>
        <div><strong>Email</strong><span>{COMPANY.email}</span></div>
      </div>
      <div className="c-detail">
        <div className="c-icon"><Phone size={17} /></div>
        <div><strong>Phone</strong><span>{COMPANY.phone}</span></div>
      </div>
      <div className="c-detail">
        <div className="c-icon"><Clock size={17} /></div>
        <div><strong>Response Time</strong><span>{COMPANY.responseTime}</span></div>
      </div>
    </>
  );
}
